import { tokenState } from './getNewToken';
export var getAccessTokenFromMemory = function getAccessTokenFromMemory() {
  var accessToken = tokenState.accessToken,
      expiryDate = tokenState.expiryDate;
  var now = new Date();

  if (!accessToken || !expiryDate || expiryDate < now.getTime()) {
    return undefined;
  }

  return accessToken;
};